<template>
  <div class="mt-2">
    <span :class="claseError" class="ma-0">{{titulo}}</span>
    <span v-if="obligatorio" :class="claseError">*</span>
    <IconoInformacion :sInformacion="sInformacion"/>

      <v-radio-group v-model="valor" row class="ma-0">
        <v-radio v-for="(aData, key) in aDataCheck" :key="key" :label="aData.texto" :value="aData.id+''"
        ></v-radio>
      </v-radio-group>  
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import FormMixin from '@/mixins/formularioMixin.js'
import IconoInformacion from '@/components/Form/Componentes/subComponentes/IconoInformacion.vue'


export default {
  name: 'FormMultipleRadioButton',
  mixins: [FormMixin],
  components: {
    IconoInformacion,
  },
  props: {
    aDataCheck:{
      default: []
    }
  },
  data() {
    return {
      valor   : this.value,
      esError : false,
      noVacio : [v => !!v],
      bEditable       : (this.editable == "0") ? true : false,
    }
  },
  mounted(){
  },
  methods: {

  },
  computed: {
    ...mapGetters(['getoFormError'])
  },
  watch: {
    valor(NewValor){
      this.$emit('input',`${NewValor}`)
      if(this.esError && this.valor != ''){
        this.esError = false
      }      
    },
    value(NewValue){
      this.valor = NewValue
    },
    getoFormError(){
      this.esError = this.getoFormError[this.campo]
    }
  },
  
}
</script>

<style scoped>


</style>